import * as React from "react";
import IconButton from "@material-ui/core/IconButton";
import {
  WithStyles,
  withStyles,
  StyleRulesCallback,
  Avatar,
  Menu,
  MenuItem
} from '@material-ui/core';
import Icon from "../../Icon/Icon";

interface IProps {
  isOpen : boolean;
  isSignedIn : boolean;
  onSignOut : () => void;
  onMenuToggled : () => void;
  onMenuClosed : () => void;
  className?: string;
  avatarUrl?: string;
  isMyAccount?: boolean
}

const styles : StyleRulesCallback = ({palette, spacing}) => ({
  avatar: {
    width: 32,
    height: 32
  },
  signOut: {
    fontSize: 14,
    color: "white",
    textDecoration: "underline",
    cursor: "pointer"
  }
})

@(withStyles(styles)as any)
export default class MenuButton extends React.Component < IProps & Partial < WithStyles < any > > > {
  private profileEl : any;
  public render() {
    const {isOpen, onMenuClosed, className, classes, isMyAccount} = this.props;

    return (
        isMyAccount? <div className={classes!.signOut} onClick={this.signOut}>Sign out</div>:
      <div className={className}>
        <IconButton
          aria-owns={open
          ? "menu-appbar"
          : undefined}
          aria-haspopup="true"
          onClick={this.onMenuToggled}>
          {this.renderAvatar()}
        </IconButton>
        <Menu
          id="menu-appbar"
          anchorOrigin={{
          vertical: "top",
          horizontal: "right"
        }}
          transformOrigin={{
          vertical: "top",
          horizontal: "right"
        }}
          anchorEl={this.profileEl}
          open={isOpen}
          onClose={onMenuClosed}>
          <MenuItem onClick={this.signOut}>Sign Out</MenuItem>
        </Menu>
      </div>
    );
  }

  private renderAvatar() {
    const {avatarUrl, classes} = this.props;
    if (avatarUrl) {
      return (<Avatar src={avatarUrl} className={classes !.avatar}/>)
    } else {
      return <Icon icon={'settings'}/>
    }
  }

  private onMenuToggled = (event : any) => {
    this.profileEl = event.currentTarget;
    this
      .props
      .onMenuToggled();
  };

  private signOut = () => {
    const {onMenuClosed, onSignOut} = this.props;
    onMenuClosed();
    onSignOut();
  };
}



// WEBPACK FOOTER //
// ./src/components/Header/MenuButton/MenuButton.tsx